<template>
    <div class="p-0 flex-grow-1 text-dark-50 py-2 py-lg-2">
        <div class="py-2">
            <span class="mr-2">
                <span class="svg-icon svg-icon-success">
                    <PenSvg />
                </span>
            </span>
            <span class="text-dark-50">{{
                presentation.author_credentials.editorial_consultant_used
            }}</span>
        </div>
    </div>
</template>

<script>
import PenSvg from "@/svg/PenSvg.vue";

export default {
    components: { PenSvg },

    props: ["presentation"],
};
</script>
